// OfflineBanner — warning-полоска когда нет соединения. Рендерится внутри
// общего <BannerStack>. Опционально показывает счётчик очереди sync.
// См. rules/offline-sync.md §2.5b.
import { IconWifiOff } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useOnlineStatus } from "@/hooks/use-online-status";
import { usePendingSyncCount } from "@/hooks/use-pending-sync-count";

export function OfflineBanner(): React.ReactElement | null {
	const isOnline = useOnlineStatus();
	const pending = usePendingSyncCount();
	const { t } = useTranslation("common");
	if (isOnline) return null;
	// Фон НЕПРОЗРАЧНЫЙ (`tint-warning` = `--sh-warning-bg`), а не `bg-warning/10`:
	// стек баннеров — `fixed` под шапкой, и полупрозрачная полоса пропускала
	// сквозь себя проезжающий контент, из-за чего надпись не читалась при скролле
	// (жалоба 2026-08-19). Утилита несёт и парный цвет текста, поэтому с иконки и
	// текста собственные цвета сняты.
	return (
		<div
			role="status"
			aria-live="polite"
			className="flex items-center justify-center gap-2 border-b border-warning/30 px-4 py-2 text-sm tint-warning"
		>
			<IconWifiOff size={16} stroke={1.75} />
			<span>
				{pending > 0 ? t("offline.bannerWithQueue", { count: pending }) : t("offline.banner")}
			</span>
		</div>
	);
}
